// action/visitorId/visitorIdSelector.js
export const selectVisitorId = (state) => state.visitorIdCurrent.visitorId;
